/**
 * BaseCustomEventData is the base type for all custom event data objects.
 *
 * key - unique identifier for the custom event
 * comment - optional comment to add to the custom event to add more verbose context
 */
export type BaseCustomEventData = { comment?: string; key: string };

/**
 * WARNING: changing keys will potentially break existing dashboards/queries in DataDog and/or LogRocket
 * PLEASE LEAVE A COMMENT DESCRIBING WHAT THE EVENT IS TRACKING
 */
export const customEventKeys = {
  cart: {
    loaded: 'cart_loaded',
    checkout: 'checkout_initiated',
  },
  notification: 'notification_displayed',
  printing: {
    jobStarted: 'print_job_started',
    jobEnded: 'print_job_ended',
  },
  scanning: {
    scanReceived: 'scan_received',
    idCameraScanResult: 'mobile-checkout_id_camera-scan-result', // Result of decoding an ID barcode off the camera (POS-21494)
    idUploadScanResult: 'mobile-checkout_id_upload-scan-result', // Result of decoding an ID barcode out of an uploaded image (POS-21494)
    idPhotoSaveFailed: 'mobile-checkout_id_photo-save-failed', // Entry landed but the opted-in ID photo did not save (POS-21494)
  },
};
